import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Settings {
    '본인급여 확인 가능': boolean;
    '사업장 급여 확인 가능': boolean;
    '직원 급여 / 일정 확인 및 수정 가능': boolean;
    '출퇴근기록 수정 가능': boolean;
    '타직원 출퇴근 알람 받기': boolean;
}

const initialState = { values: [false, false, false, false, false, false] };

export const settingsSlice = createSlice({
    name: 'settingsState',
    initialState,
    reducers: {
        setSettings: (state, action: PayloadAction<{ key: number; value: boolean }>) => {
            state.values[action.payload.key] = action.payload.value;
        },
    },
});

export const { setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
